// extracted by mini-css-extract-plugin
export default {"overlay":"LoginPopup_overlay__s0TqL","modal":"LoginPopup_modal__gnRRs","closeBtn":"LoginPopup_closeBtn__DzBPn","form":"LoginPopup_form__Gd-fS","error":"LoginPopup_error__xSv0A"};